/* unplugin-vue-components disabled */import { render } from "./pointlistapp.vue?vue&type=template&id=039558f9&scoped=true"
import script from "./pointlistapp.vue?vue&type=script&lang=js"
export * from "./pointlistapp.vue?vue&type=script&lang=js"

import "./pointlistapp.vue?vue&type=style&index=0&id=039558f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039558f9"]])

export default __exports__